import http from "@/services/http";
import { categorizeCommunities } from "@/utils/communitiesUtils";

export async function fetch() {
  const { data } = await http().get(
    `${globalThis.env.API_APOLLO_MIDDLEWARE}/Communities`
  );

  return categorizeCommunities(data);
}

export async function fetchEthicalHackerCommunity() {
  const { data } = await http().get(
    `${globalThis.env.API_APOLLO_MIDDLEWARE}/Communities`
  );

  return {
    ethicalHackerCommunity: data.find((community: any) => {
      return (
        community.Name?.includes("Ethical Hacker") ||
        community.Name?.includes("Ethical Hacking")
      );
    }),
  };
}
